(function () {
  'use strict';

  // Madeira MTB Experience raffle reward — override the generic "GET REWARD" label per locale.
  var REWARD_ID = '239686';
  var LABEL_DE = 'Jetzt teilnehmen';
  var LABEL_EN = 'SIGN UP NOW';

  function label() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('de') === 0 ? LABEL_DE : LABEL_EN;
  }

  function applyLabel() {
    var button = document.querySelector(
      '#loyaltylion .lion-reward-item[data-reward-id="' + REWARD_ID + '"] .lion-action-button'
    );
    if (button && button.textContent.trim() !== label()) {
      button.textContent = label();
    }
  }

  // LoyaltyLion injects #loyaltylion itself, asynchronously, well after this script runs — so
  // observe document.body (always present) instead of waiting for #loyaltylion to exist first.
  applyLabel();
  new MutationObserver(applyLabel).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
